import { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { storage } from '../utils/storage';

type Theme = 'light' | 'dark';

interface ThemeContextValue {
  theme: Theme;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

const STORAGE_KEY = 'azocsii-theme';

function getInitialTheme(): Theme {
  // Phase 0-A 다크모드 일시 중단 (2026-04-15)
  // 출시 후 리브랜딩 시 아래 원래 로직으로 복구 예정.
  return 'light';

  // === 원래 로직 (복구용 보존) ===
  // if (typeof window === 'undefined') return 'light';
  // const saved = localStorage.getItem(STORAGE_KEY) as Theme | null;
  // if (saved === 'light' || saved === 'dark') return saved;
  // if (window.matchMedia('(prefers-color-scheme: dark)').matches) return 'dark';
  // return 'light';
}

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<Theme>(getInitialTheme);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') root.classList.add('dark');
    else root.classList.remove('dark');
    storage.set(STORAGE_KEY, theme);
  }, [theme]);

  const toggleTheme = () => setTheme(prev => prev === 'light' ? 'dark' : 'light');

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}
